import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TCommunitiesState = {
  // TODO types
  communitiesList: any[];
  // selectedCommunityUuid?: string;
  inBuildCommunity: boolean;
  communityToCompare: string | null;
  selectedTimelineInterval: string | null;
};

export const initialCommunitiesState: TCommunitiesState = {
  communitiesList: [],
  // selectedCommunityUuid: undefined,
  inBuildCommunity: false,
  communityToCompare: null,
  selectedTimelineInterval: null,
};

const communitiesSlice = createSlice({
  name: 'communities',
  initialState: initialCommunitiesState,
  reducers: {
    setCommunitiesList(state, action: PayloadAction<TCommunitiesState['communitiesList']>) {
      state.communitiesList = action.payload;
    },
    setInBuildCommunityUuid(state, action: PayloadAction<TCommunitiesState['inBuildCommunity']>) {
      state.inBuildCommunity = action.payload;
    },
    // setSelectedCommunityUuid(
    //   state,
    //   action: PayloadAction<TCommunitiesState['selectedCommunityUuid']>,
    // ) {
    //   state.selectedCommunityUuid = action.payload;
    // },
    setCommunityToCompare(state, action: PayloadAction<TCommunitiesState['communityToCompare']>) {
      state.communityToCompare = action.payload;
    },
    setSelectedTimelineInterval(
      state,
      action: PayloadAction<TCommunitiesState['selectedTimelineInterval']>,
    ) {
      state.selectedTimelineInterval = action.payload;
    },
  },
});

// Actions
export const {
  setCommunitiesList,
  setCommunityToCompare,
  setInBuildCommunityUuid,
  // setSelectedCommunityUuid,
  setSelectedTimelineInterval,
} = communitiesSlice.actions;

// Reducer
export const communitiesReducer = communitiesSlice.reducer;
